// extracted by mini-css-extract-plugin
module.exports = {"projectsDashboardHeader":"ProjectsDashboardHeader_projectsDashboardHeader__11Xyd","title":"ProjectsDashboardHeader_title__1gP48"};